import React from 'react';
import { useLocation } from 'react-router-dom';
import { ContextBar } from './components/ContextBar';
import { AUDITORIA_BASE, useAuditoriaContext } from './useAuditoriaContext';

// Telas multi-empresa (carteira): a topbar esconde a ficha da empresa.
const MULTI_SEGS = ['escritorio', 'fechamento'];

/**
 * Topbar GLOBAL do módulo (busca de empresa + período). É renderizada pelo
 * Layout — FORA do `{children}` — então fica fixa logo abaixo do header
 * principal e NÃO remonta ao navegar entre submódulos: uma única instância,
 * compartilhada por todo o módulo (o estado vive na URL via useAuditoriaContext).
 */
export function AuditoriaTopbar() {
  const ctx = useAuditoriaContext();
  const { pathname } = useLocation();
  const seg = pathname.slice(`${AUDITORIA_BASE}/`.length);
  return (
    <ContextBar
      empresa={ctx.empresa}
      onSelectEmpresa={ctx.onSelectEmpresa}
      onClearEmpresa={ctx.onClearEmpresa}
      periodo={ctx.periodo}
      onPeriodo={ctx.onPeriodo}
      multi={MULTI_SEGS.includes(seg)}
    />
  );
}
